import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "exitIconSmall",
  "use": "exitIconSmall-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"exitIconSmall\"><g data-name=\"icon - exit - 24px\"><path d=\"M0 0h16v16H0z\" fill=\"none\" /><path data-name=\"↳color\" d=\"M9.05 8.132l5.253-5.253a.835.835 0 0 0-1.182-1.181L7.869 6.952 2.616 1.698a.835.835 0 0 0-1.181 1.181L6.69 8.132l-5.255 5.253a.835.835 0 1 0 1.181 1.181l5.253-5.253 5.253 5.253a.835.835 0 0 0 1.181-1.181z\" fill=\"#031425\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol